"use client";

import SearchIcon from "@/components/custom/icons/search";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useSearchConditionStore } from "@/stores/searchConditionStore";
import { useState } from "react";
import MediaListView from "../../components/media-list/MediaListView";
import NoProductDialog from "./NoProductDialog";
import { useTypedTranslations } from "@/i18n/typed";

export default function MediaListMediaRole() {
  const t = useTypedTranslations("mediaOnMap");

  const dataList = [
    { name: t("sort.byTraffic"), code: "KR" },
    { name: t("sort.byExposure"), code: "QA", disabled: true },
    { name: t("sort.byAttention"), code: "QS", disabled: true },
  ];
  const [isNoProduct, setIsNoProduct] = useState(false);
  const { isMyMedia } = useSearchConditionStore();
  const [search, setSearch] = useState("");

  return (
    <>
      <SheetHeader className="px-2.5 py-2 border-b">
        <SheetTitle className="py-[3px]">
          <div className="flex flex-col space-y-2 w-full items-start">
            <Input
              disabled={!isMyMedia}
              className="[&_input::placeholder]:text-gray-400 font-medium "
              placeholder={
                !isMyMedia
                  ? t("search.disabledPlaceholder")
                  : t("search.placeholder")
              }
              prefix={<SearchIcon />}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Select>
              <SelectTrigger size="sm" className="w-[160px]">
                <SelectValue
                  placeholderClassName="text-sm font-medium"
                  placeholder={t("sort.placeholder")}
                />
              </SelectTrigger>
              <SelectContent>
                {dataList.map((p) => (
                  <SelectItem key={p.code} value={p.code} disabled={p.disabled}>
                    {p.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </SheetTitle>
      </SheetHeader>
      <MediaListView search={search} />
      <NoProductDialog
        open={isNoProduct}
        onClose={() => setIsNoProduct(false)}
      />
    </>
  );
}
